import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Comma-separated text input → clean array (skills, regions, …). */
export function parseCommaList(input: string): string[] {
  return input
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
}

/**
 * Uppercase avatar initials — the one implementation for people and
 * companies. Two-letter form uses first + last word ("Ananya Rao Sharma" →
 * "AS", single word → first two letters); `count: 1` gives one letter.
 */
export function initials(
  name: string | null | undefined,
  count: 1 | 2 = 2,
): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  if (count === 1) return parts[0]![0]!.toUpperCase()
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}
